// extracted by mini-css-extract-plugin
module.exports = {"companyInfoArea":"infoList_companyInfoArea__rp7Un","companyInfoListWrap":"infoList_companyInfoListWrap__6Fegj","companyInfoList":"infoList_companyInfoList__5mHMR"};